import { CheckCircle, WarningCircle, XCircle, Info, MinusCircle } from "@phosphor-icons/react";

// Oct 13 2026, user's explicit ask ("eliminate this pill design across
// the app... make sure it is ERP-level professional... 'Posted' in a
// box is unprofessional, put it the other way around, the way we have
// it [on the STO page]") - shared app-wide replacement for colored
// pill/box status badges: a plain icon + Title Case text in the
// semantic color, no background/border box at all.
const STATUS_ICON_TONES = {
  success: { Icon: CheckCircle, color: "#15803D" },
  warning: { Icon: WarningCircle, color: "#B45309" },
  danger: { Icon: XCircle, color: "#B91C1C" },
  info: { Icon: Info, color: "#175CD3" },
  neutral: { Icon: MinusCircle, color: "#475569" },
};

export const StatusText = ({ tone, children, testId, title, className = "" }) => {
  const { Icon, color } = STATUS_ICON_TONES[tone];
  // Oct 13 2026, user's explicit ask ("Created In SAP almost touching the
  // border, should be in two lines ideally - same with GST Recorded
  // overflowing into the next line") - plain `inline` flow (not flex) so
  // the icon stays glued to the text's first word while the text itself
  // wraps naturally onto a 2nd line inside a narrow fixed-width table
  // column, instead of a nowrap flex row spilling past the cell edge.
  return (
    <span className={`inline font-medium leading-snug ${className}`} style={{ color }} data-testid={testId} title={title}>
      <Icon size={13} weight="fill" className="inline-block align-text-bottom mr-1" />
      {children}
    </span>
  );
};
